import React, { useEffect } from 'react';
import { CommandPaletteSearchHeader } from './CommandPaletteSearchHeader';
import { CommandPaletteDivider } from './CommandPaletteDivider';
import { CommandPaletteGroup } from './CommandPaletteGroup';
import { CommandPaletteFooter } from './CommandPaletteFooter';
import styles from '../command-palette.scss';
import { panes } from '../config/groups';
import { useRovingTabIndexContext } from '../context/rovingTabIndexContext/RovingTabIndexContext';
import PropTypes from 'prop-types';

export const CommandPaletteModalContent = ({ inputRef, open }) => {
  const rovingTabIndex = useRovingTabIndexContext();
  const [search, setSearch] = React.useState('');

  // Reset roving tabindex when search changes or modal opens/closes
  useEffect(() => {
    rovingTabIndex.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleContentKeyDown = (e) => {
    // Handle arrow navigation when focus is within the content area
    if (
      e.key === 'ArrowDown' ||
      e.key === 'ArrowUp' ||
      e.key === 'Home' ||
      e.key === 'End'
    ) {
      rovingTabIndex.handleKeyDown(e);
    } else {
      const isPrintableChar =
        e.key.length === 1 &&
        !e.ctrlKey &&
        !e.altKey &&
        !e.metaKey &&
        !e.shiftKey;
      const isBackspace = e.key === 'Backspace';
      if (isPrintableChar) {
        e.preventDefault();
        setSearch(search + e.key);
        inputRef.current?.focus();
      }
      if (isBackspace) {
        e.preventDefault();
        setSearch(search.slice(0, -1));
        inputRef.current?.focus();
      }
    }
  };

  const handleSearchKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        rovingTabIndex.focusFirst();
        break;
      case 'ArrowUp':
        e.preventDefault();
        rovingTabIndex.focusLast();
        break;
      default:
        break;
    }
  };
  const defaultPane = panes.find((pane) => pane.paneId === 'default');

  return (
    <>
      <CommandPaletteSearchHeader
        search={search}
        setSearch={setSearch}
        ref={inputRef}
        onKeyDown={handleSearchKeyDown}
      />
      <CommandPaletteDivider />

      {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
      <div
        className={styles.commandPaletteContent}
        onKeyDown={handleContentKeyDown}
        role="listbox"
        aria-label="Command palette results"
      >
        {defaultPane.groups.map((group) => (
          <CommandPaletteGroup
            key={group.groupName.value}
            search={search}
            group={group}
            paneId={defaultPane.paneId}
          />
        ))}
      </div>

      <CommandPaletteDivider />
      <CommandPaletteFooter />
    </>
  );
};

CommandPaletteModalContent.propTypes = {
  inputRef: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
};
